import * as types from "../action-types";

export default (state = {}, action) => {
  switch (action.type) {
    case types.SELECT_REGISTRATION:
      return { ...action.data };
    case types.CLEAR_SELECTED_REGISTRATION:
      return {};
    default:
      return state;
  }
};
